import store from "@/state/store";

let menuObjects;

var home_page = 'index';
if(typeof process.env.VUE_APP_HOMEPAGE !== 'undefined' ){
   home_page = process.env.VUE_APP_HOMEPAGE;
}

menuObjects = [
    {
        path: "/",
        name: "home",
        meta: {
            authRequired: true,
            access: "dashboard",
            accessObject: "/",
        },
        component: () => import("../views/pages/dashboard/"+home_page),
    }
]


// if(process.env.VUE_APP_TENANT === 'MON')
// {
//   menuObjects = [
//     {
//       path: "/",
//       name: "home",
//       meta: {
//         authRequired: true,
//         access: "dashboard",
//         accessObject: "/",
//       },
//       component: () => import("../views/pages/dashboard/monitoring"),
//     }
//   ]
// }else{
//   menuObjects = [
//     {
//       path: "/",
//       name: "home",
//       meta: {
//         authRequired: true,
//         access: "dashboard",
//         accessObject: "/",
//       },
//       component: () => import("../views/pages/dashboard/index"),
//     }
//   ]
// }

export default [
  ...menuObjects,
  {
    path: "/login",
    name: "login",
    component: () => import("../views/pages/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["authapi/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
      accessObject: "/login",
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/pages/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["authapi/loggedIn"]) {
          // Redirect to the home page instead
          next({
            name: "home",
          });
        } else {
          // Continue to the login page
          next();
        }
      },
      accessObject: "/forgot-password",
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch("auth/logOut");
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          store.dispatch("authfack/logout");
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "api") {
          store.dispatch("authapi/logout");
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute
            ? {
                name: "home",
              }
            : {
                ...routeFrom,
              }
        );
      },
      accessObject: "/logout",
    },
  },
  {
    path: "/customers",
    name: "customers",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers",
    },
    component: () => import("../views/pages/customers/index"),
  },
  {
    path: "/customers/profile/:id",
    name: "customers_profile",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/profile/:id",
    },
    component: () => import("../views/pages/customers/profile"),
    props: true,
  },
  {
    path: "/customers/group_details/:group_id",
    name: "customers_group_details",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/group_details/:group_id",
    },
    component: () => import("../views/pages/customers/group_details"),
    props: true,
  },
  {
    path: "/customers/requests",
    name: "customers_requests",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/requests",
    },
    component: () => import("../views/pages/customers/customers_requests"),
    props: true,
  },
  {
    path: "/customers/blocked_users",
    name: "blocked_users",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/blocked_users",
    },
    component: () => import("../views/pages/customers/blocked_users"),
    props: true,
  },
  {
     path: "/customers/optins",
     name: "optins",
     meta: {
       authRequired: true,
       access: "customers",
       accessObject: "/customers/optins",
     },
     component: () => import("../views/pages/customers/optins"),
     props: true,
  },
  {
    path: "/customers/groups",
    name: "groups",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/groups",
    },
    component: () => import("../views/pages/customers/groups"),
    props: true,
  },
  {
    path: "/customers/emails",
    name: "emails",
    meta: {
      authRequired: true,
      access: "customers_emails",
      accessObject: "/customers/emails",
    },
    component: () => import("../views/pages/customers/emails"),
    props: true,
  },
  {
    path: "/customers/devices",
    name: "devices",
    meta: {
      authRequired: true,
      access: "customers",
      accessObject: "/customers/devices",
    },
    component: () => import("../views/pages/customers/devices"),
    props: true,
  },
  {
    path: "/business/labels",
    name: "business_labels",
    meta: {
      authRequired: true,
      access: "business",
      accessObject: "/business/labels",
    },
    component: () => import("../views/pages/business/labels"),
    props: true,
  },
  {
    path: "/business/companies",
    name: "companies",
    meta: {
      authRequired: true,
      access: "business",
      accessObject: "/business/companies",
    },
    component: () => import("../views/pages/customers/companies"),
    props: true,
    },
    {
        path: "/customers/companies/:id",
        name: "company_profile",
        meta: {
            authRequired: true,
            access: "customers",
            accessObject: "/customers/companies/:id",
        },
        component: () => import("../views/pages/customers/company_profile"),
        props: true,
    },
  {
    path: "/teams/list",
    name: "teams_list",
    meta: {
      authRequired: true,
      access: "teams",
      accessObject: "/teams/list",
    },
    component: () => import("../views/pages/teams/list"),
    props: true,
  },
  {
    path: "/teams/squad",
    name: "teams_squad",
    meta: {
      authRequired: true,
      access: "teams",
      accessObject: "/teams/squad",
    },
    component: () => import("../views/pages/teams/squad"),
    props: true,
  },
  {
    path: "/youtube_setup",
    name: "youtube_setup",
    meta: {
      authRequired: true,
      access: "youtube_setup",
      accessObject: "/youtube_setup",
    },
    component: () => import("../views/pages/monitor/youtube_setup"),
    props: true,
  },
  {
    path: "/teams/list_sport",
    name: "list_sport",
    meta: {
      authRequired: true,
      access: "teams",
      accessObject: "/teams/list_sport",
    },
    component: () => import("../views/pages/teams/list_sport"),
    props: true,
  },
  // {
  //   path: "/fixtures/featured_matches",
  //   name: "fixtures_featured_matches",
  //   meta: {
  //     authRequired: true,
  //     access: "fixtures",
  //     accessObject: "/fixtures/featured_matches",
  //   },
  //   component: () => import("../views/pages/fixtures/featured_matches"),
  //   props: true,
  // },
  {
    path: "/fixtures/rounds",
    name: "fixtures_rounds",
    meta: {
      authRequired: true,
      access: "fixtures",
      accessObject: "/fixtures/rounds",
    },
    component: () => import("../views/pages/fixtures/rounds"),
    props: true,
  },
  {
    path: "/fixtures/standings",
    name: "fixtures_standings",
    meta: {
      authRequired: true,
      access: "fixtures",
      accessObject: "/fixtures/standings",
    },
    component: () => import("../views/pages/fixtures/standings"),
    props: true,
  },
  {
    path: "/games/social",
    name: "social",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/social",
    },
    component: () => import("../views/pages/games/social"),
    props: true,
  },
  {
    path: "/games/collectibles",
    name: "collectibles",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/collectibles",
    },
    component: () => import("../views/pages/games/collectibles"),
    props: true,
  },
  {
    path: "/games/pack_details/:pack_id",
    name: "games_pack_details",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/pack_details/:pack_id",
    },
    component: () => import("../views/pages/games/pack_details"),
    props: true,
  },
  {
    path: "/games/words",
    name: "words",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/words",
    },
    component: () => import("../views/pages/games/words"),
    props: true,
  },
  {
    path: "/games/game_words",
    name: "game_words",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/game_words",
    },
    component: () => import("../views/pages/games/game_words"),
    props: true,
  },
  {
    path: "/games/leaderboard",
    name: "leaderboard",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/leaderboard",
    },
    component: () => import("../views/pages/games/leaderboard"),
    props: true,
  },
  // {
  //   path: "/games/social",
  //   name: "social",
  //   meta: {
  //     authRequired: true,
  //     access: "games",
  //     accessObject: "/games/social",
  //   },
  //   component: () => import("../views/pages/games/social"),
  //   props: true,
  // },
  {
    path: "/games/mini_games",
    name: "mini_games",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/mini_games",
    },
    component: () => import("../views/pages/games/mini_games"),
    props: true,
  },
  {
    path: "/advertising/banner",
    name: "advertising_banner",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/banner",
    },
    component: () => import("../views/pages/advertising/banner"),
    props: true,
  },
  {
    path: "/advertising/advertorial",
    name: "advertising_advertorial",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/advertorial",
    },
    component: () => import("../views/pages/advertising/advertorial"),
    props: true,
  },
  {
    path: "/advertising/sponsors",
    name: "advertising_sponsors",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/sponsors",
    },
    component: () => import("../views/pages/advertising/sponsors"),
    props: true,
  },
  {
    path: "/advertising/sponsor/:id",
    name: "advertising_sponsor",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/sponsor/:id",
    },
    component: () => import("../views/pages/advertising/sponsor"),
    props: true,
  },
  {
    path: "/advertising/player",
    name: "advertising_player",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/player",
    },
    component: () => import("../views/pages/advertising/player"),
    props: true,
  },
  {
    path: "/advertising/advertisements",
    name: "advertisements",
    meta: {
      authRequired: true,
      access: "advertising",
      accessObject: "/advertising/advertisements",
    },
    component: () => import("../views/pages/advertising/advertisements"),
    props: true,
  },
  {
    path: "/advertising/deals",
    name: "Deals",
    meta: {
        authRequired: false,
        access: "advertising",
        accessObject: "/advertising/deals",
    },
    component: () => import("../views/pages/advertising/deals"),
    props: true,
    },
    {
      path: "/advertising/app_ads",
      name: "advertising_app_ads",
      meta: {
        authRequired: true,
        access: "advertising",
        accessObject: "/advertising/app_ads",
      },
      component: () => import("../views/pages/advertising/app_ads"),
      props: true,
    },
  {
    path: "/news/feed",
    name: "rss_news",
    meta: {
      authRequired: true,
      access: "news",
      accessObject: "/news/feed",
    },
    component: () => import("../views/pages/news/feed"),
    props: true,
  },
  {
    path: "/news/sport_news_feed",
    name: "rss_sport_news_feed",
    meta: {
      authRequired: true,
      access: "news",
      accessObject: "/news/sport_news_feed",
    },
    component: () => import("../views/pages/news/sport_news_feed"),
    props: true,
  },
  {
    path: "/news/videos",
    name: "rss_videos",
    meta: {
      authRequired: true,
      access: "news",
      accessObject: "/news/videos",
    },
    component: () => import("../views/pages/news/videos"),
    props: true,
  },
  {
    path: "/news/shorts",
    name: "shosts",
    meta: {
       authRequired: true,
       access: "shorts",
       accessObject: "/news/shorts",
    },
    component: () => import("../views/pages/news/shorts"),
    props: true,
  },
  {
    path: "/news/editorials",
    name: "editorials",
    meta: {
      authRequired: true,
      access: "editorials",
      accessObject: "/news/editorials",
    },
    component: () => import("../views/pages/news/editorials"),
    props: true,
  },
  {
    path: "/videos/video-projects",
    name: "video-projects",
    meta: {
      authRequired: true,
      access: "videos",
      accessObject: "/videos/video-projects",
    },
    component: () => import("../views/pages/news/video_projects"),
  },
  {
    path: "/content/social_upload",
    name: "social_upload",
    meta: {
      authRequired: true,
      access: "social_upload",
      accessObject: "/content/social_upload",
    },
    component: () => import("../views/pages/news/social_upload"),
  },
  {
    path: "/content/social_create_post",
    name: "social_create_post",
    meta: {
      authRequired: true,
      access: "social_upload",
      accessObject: "/content/social_upload",
    },
    component: () => import("../views/pages/news/social_create_post"),
  },
  {
    path: "/videos/video-editor",
    name: "video-editor",
    meta: {
      authRequired: true,
      access: "videos",
      accessObject: "/videos/video-editor",
    },
    component: () => import("../views/pages/news/video_editor"),
  },
  {
    path: "/news/liveblog",
    name: "liveblog",
    meta: {
      authRequired: true,
      access: "liveblog",
      accessObject: "/news/liveblog",
    },
    component: () => import("../views/pages/news/liveblog"),
    props: true,
  },
  {
    path: "/business/news",
    name: "rss_news_business",
    meta: {
      authRequired: true,
      access: "business_news",
      accessObject: "/business/news",
    },
    component: () => import("../views/pages/news/news_business"),
    props: true,
  },
  {
    path: "/business/events",
    name: "rss_events_business",
    meta: {
      authRequired: true,
      access: "business_events",
      accessObject: "/business/events",
    },
    component: () => import("../views/pages/news/events_business"),
    props: true,
  },
  {
    path: "/business/wall",
    name: "business_wall",
    meta: {
      authRequired: true,
      access: "business_wall",
      accessObject: "/business/wall",
    },
    component: ()=> import("../views/pages/business/business_wall"),
    props: true,
  },
  {
    path: "/business/users",
    name: "business_users",
    meta: {
      authRequired: true,
      access: "business_users",
      accessObject: "/business/users",
    },
    component: () => import("../views/pages/business/business_users"),
    props: true,
  },
  {
    path: "/games/player_of_the_month",
    name: "player_of_the_month",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/player_of_the_month",
    },
    component: () => import("../views/pages/games/player_of_the_month"),
    props: true,
  },
  {
    path: "/games/man_of_the_match",
    name: "man_of_the_match",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/man_of_the_match",
    },
    component: () => import("../views/pages/games/man_of_the_match"),
    props: true,
  },
  {
    path: "/games/poll",
    name: "poll",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/poll",
    },
    component: () => import("../views/pages/games/poll"),
    props: true,
  },
  {
    path: "/games/poll/statistics/:id",
    name: "poll_statistics",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/poll/statistics/:id",
    },
    component: () => import("../views/pages/games/showPollAnswerStatistics"),
    props: true,
  },
  {
    path: "/merchandising/products",
    name: "merchandising_products",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/products",
    },
    component: () => import("../views/pages/merchandising/products"),
    props: true,
  },
  {
    path: "/merchandising/product_details/:id",
    name: "product_details",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/product_details/:id",
    },
    component: () => import("../views/pages/merchandising/product_details"),
    props: true,
  },
  {
      path: "/merchandising/media",
      name: "merchandising_media",
      meta: {
          authRequired: true,
          access: "merchandising",
          accessObject: "/merchandising/media",
      },
      component: () => import("../views/pages/merchandising/media"),
      props: true,
  },
  {
      path: "/merchandising/promotions",
    name: "merchandising_promotions",
      meta: {
          authRequired: true,
          access: "merchandising",
        accessObject: "/merchandising/promotions",
      },
      component: () => import("../views/pages/merchandising/promotions"),
      props: true,
  },
  {
    path: "/merchandising/categories",
    name: "merchandising_categories",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/categories",
    },
    component: () => import("../views/pages/merchandising/categories"),
    props: true,
  },
  {
    path: "/merchandising/brands",
    name: "merchandising_brands",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/brands",
    },
    component: () => import("../views/pages/merchandising/brands"),
    props: true,
  },
  {
    path: "/merchandising/pod_report",
    name: "merchandising_pod_report",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/pod_report",
    },
    component: () => import("../views/pages/merchandising/pod_report"),
    props: true,
  },
  {
    path: "/merchandising/app_products",
    name: "merchandising_app_products",
    meta: {
       authRequired:true,
       access:"merchandising",
       accessObject: "/merchandising/app_products",
    },
    component: ()=> import("../views/pages/merchandising/app_products"),
    props: true,
  },
  {
    path: "/best_sellers",
    name: "best_sellers",
    meta: {
      authRequired: true,
      access: "best_sellers",
      accessObject: "/best_sellers",
    },
    component: () => import("../views/pages/merchandising/best_sellers"),
    props: true,
  },
  {
    path: "/merchandising/brand_details/:id",
    name: "brand_details",
    meta: {
      authRequired: true,
      access: "merchandising",
      accessObject: "/merchandising/brand_details/:id",
    },
    component: () => import("../views/pages/merchandising/brand_details.vue"),
    props: true,
  },
  {
    path: "/games/guess_the_score",
    name: "guess_the_score",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/guess_the_score",
    },
    component: () => import("../views/pages/games/guess_the_score"),
    props: true,
  },
  {
    path: "/monitor/quiz",
    name: "monitor_quiz",
    meta: {
      authRequired: true,
      access: "monitor",
      accessObject: "/monitor/quiz",
    },
    component: () => import("../views/pages/monitor/quiz.vue"),
    props: true,
  },
  {
    path: "/monitor/quiz/bulk-approval",
    name: "monitor_quiz_bulk_approval",
    meta: {
      authRequired: true,
      access: "monitor",
      accessObject: "/monitor/quiz",
    },
    component: () => import("../views/pages/monitor/quiz_bulk_approval.vue"),
    props: true,
  },
  {
    path: "/games/quiz",
    name: "tenant_quiz",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/quiz",
    },
    component: () => import("../views/pages/games/quiz_question.vue"),
    props: true,
  },
  {
    path: "/games/downloads",
    name: "games_downloads",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/downloads",
    },
    component: () => import("../views/pages/games/downloads.vue"),
    props: true,
  },
  {
    path: "/games/quiz/question/:id",
    name: "Quiz Question Details",
    meta: {
      authRequired:true,
      access: "games",
      accessObject:"/aws/quiz/question"
    },
    component: () => import("../views/pages/monitor/quiz_question_details.vue")
  },
  {
    path: "*",
    name: "not_found",
    meta: {
      authRequired: true,
      accessObject: "/not_found",
    },
    component: () => import("../views/pages/utility/404"),
  },
  {
    path: "/automated_notifications",
    name: "automated_notifications",
    meta: {
      authRequired: true,
      access: "automated_notifications",
      accessObject: "/automated_notifications",
    },
    component: () => import("../views/pages/notifications/automated_notifications"),
  },
  {
    path: "/notifications",
    name: "notif",
    meta: {
      authRequired: true,
      access: "push_notifications",
      accessObject: "/push_notifications",
    },
    component: () => import("../views/pages/notifications/index"),
  },
  {
    path: "/notifications/details",
    name: "notif_details",
    meta: {
      authRequired: true,
      access: "notifications",
      accessObject: "/notifications/details",
    },
    component: () => import("../views/pages/notifications/details"),
  },
  {
    path: "/notifications_setup",
    name: "notifications_setup",
    meta: {
      authRequired: true,
      access: "notifications_setup",
      accessObject: "/notifications_setup",
    },
    component: () => import("../views/pages/notifications/notifications_setup.vue"),
  },
    {
        path: "/notifications_topic",
        name: "notifications_topic",
        meta: {
            authRequired: true,
            access: "notifications_topic",
            accessObject: "/notifications_topic",
        },
        component: () => import("../views/pages/notifications/notifications_topic.vue"),
    },
  {
    path: "/notifications_types",
    name: "notifications_types",
    meta: {
      authRequired: true,
      access: "notifications_types",
      accessObject: "/notifications_types",
    },
    component: () => import("../views/pages/notifications/notification_types.vue"),
  },
  {
    path: "/notifications_type_setup",
    name: "notifications_type_setup",
    meta: {
      authRequired: true,
      access: "notifications_type_setup",
      accessObject: "/notifications_type_setup",
    },
    component: () => import("../views/pages/notifications/notifications_type_setup.vue"),
  },
  {
    path: "/monitor/queues",
    name: "monitor_queues",
    meta: {
      authRequired: true,
      access: "queues",
      accessObject: "/monitor/queues",
    },
    component: () => import("../views/pages/monitor/queues"),
  },
  {
     path: "/monitor/rbac/dashboard_access",
     name: "dashboard_access",
     meta: {
       authRequired: true,
       access: "rbac",
       accessObject: "/monitor/rbac/dashboard_access",
     },
     component: () => import("../views/pages/monitor/dashboard_access"),
    },
    {
      path: "/monitor/dashboards",
      name: "dashboards",
      meta: {
        authRequired: true,
        access: "dashboards",
        accessObject: "/monitor/dashboards",
      },
      component: () => import("../views/pages/monitor/dashboards"),
    },
    {
      path: "/monitor/documentation",
      name: "documentation",
      meta: {
        authRequired: true,
        access: "documentation",
        accessObject: "/monitor/documentation",
      },
      component: () => import("../views/pages/monitor/documentation"),
    },
    {
      path: "/monitor/ping",
      name: "monitor",
      meta: {
        authRequired: true,
        access: "monitor",
        accessObject: "/monitor/ping",
      },
      component: () => import("../views/pages/monitor/monitor_ping"),
    },
    {
        path: "/monitor/rbac/api_access",
        name: "api_access",
        meta: {
            authRequired: true,
            access: "rbac",
            accessObject: "/monitor/rbac/api_access",
        },
        component: () => import("../views/pages/monitor/api_access"),
    },
    {
        path: "/monitor/rbac/rbac_access",
        name: "rbac_access",
        meta: {
            authRequired: true,
            access: "rbac",
            accessObject: "/monitor/rbac/rbac_access",
        },
        component: () => import("../views/pages/monitor/rbac_access"),
    },
  {
    path: "/auth/rbac_setup/dashboard_access_setup",
    name: "dashboard_access_setup",
    meta: {
      authRequired: true,
      access: "rbac_setup",
      accessObject: "/auth/rbac_setup/dashboard_access_setup",
    },
    component: () => import("../views/pages/auth/dashboard_access"),
  },
  {
    path: "/auth/rbac_setup/application_methods",
    name: "application_methods",
    meta: {
      authRequired: true,
      access: "rbac_setup",
      accessObject: "/auth/rbac_setup/application_methods",
    },
    component: () => import("../views/pages/auth/application_methods"),
  },
  {
    path: "/auth/rbac_setup/api_access_setup",
    name: "api_access_setup",
    meta: {
      authRequired: true,
      access: "rbac_setup",
      accessObject: "/auth/rbac_setup/api_access_setup",
    },
    component: () => import("../views/pages/auth/api_access"),
  },
  {
    path: "/monitor/queues/:id",
    name: "monitor_queue_detail",
    meta: {
      authRequired: true,
      access: "monitor",
      accessObject: "/monitor/queues/:id",
    },
    component: () => import("../views/pages/monitor/queue_details"),
    props: true,
  },
  {
    path: "/monitor/url_details/:url_id",
    name: "monitor_url_details",
    meta: {
      authRequired: true,
      access: "monitor",
      accessObject: "/monitor/url_details/:url_id",
    },
    component: () => import("../views/pages/monitor/url_details"),
    props: true,
  },
  

  {
     path: "/monitor/terms_and_conditions",
     name: "terms_and_conditions",
     meta: {
       authRequired: true,
       access: "terms_and_conditions",
       accessObject: "/monitor/terms_and_conditions",
     },
    component: () => import("../views/pages/monitor/terms_and_conditions"),
    },
    {
      path: "/monitor/logs/api_errors",
      name: "api_errors",
      meta: {
        authRequired: true,
        access: "logs",
        accessObject: "/monitor/logs",
      },
      component: () => import("../views/pages/monitor/logs/api_errors"),
    },
    {
      path: "/monitor/logs/api_cron_logs",
      name: "api_cron_logs",
      meta: {
        authRequired: true,
        access: "logs",
        accessObject: "/monitor/logs/api_cron_logs",
      },
      component: () => import("../views/pages/monitor/logs/api_cron_logs"),
    },
    {
      path: "/monitor/logs/api_exceptions",
      name: "api_exceptions",
      meta: {
        authRequired: true,
        access: "logs",
        accessObject: "/monitor/logs/api_exceptions",
      },
      component: () => import("../views/pages/monitor/logs/api_exceptions"),
    },
    {
      path: "/monitor/logs/api_alerts",
      name: "api_alerts",
      meta: {
        authRequired: true,
        access: "logs",
        accessObject: "/monitor/logs/api_alerts",
      },
      component: () => import("../views/pages/monitor/logs/api_alerts"),
    },
    {
      path: "/monitor/database",
      name: "database",
      meta: {
        authRequired: true,
        access: "databases",
        accessObject: "/monitor/database/diff",
      },
      component: () => import("../views/pages/monitor/databases.vue")
    },
    {
      path: "/monitor/database/copy",
      name: "database_copy",
      meta: {
        authRequired: true,
        access: "databases",
        accessObject: "/monitor/database/copy",
      },
    },
  {
    path: "/monitor/check_email",
    name: "Check Email",
    meta: {
      authRequired: true,
      access: "check_email",
      accessObject: "/monitor/check_email",
    },
    component: () => import("../views/pages/monitor/check_email"),
  },
  {
    path: "/monitor/device_stats",
    name: "Device stats",
    meta: {
      authRequired: true,
      access: "device_stats",
      accessObject: "/monitor/device_stats",
    },
    component: () => import("../views/pages/monitor/device_stats"),
  },
    {
      path: "/monitor/customer_stats",
      name: "Customer stats",
      meta: {
        authRequired: true,
        access: "customer_stats",
        accessObject: "/monitor/customer_stats",
      },
      component: () => import("../views/pages/monitor/customer_stats"),
    },
    {
    path: "/application/access",
    name: "application_access",
    meta: {
      authRequired: true,
      access: "application",
      accessObject: "/application/access",
    },
    component: () => import("../views/pages/application/access"),
  },
  {
    path: "/application/config_env",
    name: "application_config_env",
    meta: {
      authRequired: true,
      access: "config_env",
      accessObject: "/application/config_env",
    },
    component: () => import("../views/pages/application/config_env"),
  },
  {
    path: "/application/config_definition",
    name: "application_config_definition",
    meta: {
      authRequired: true,
      access: "config_definition",
      accessObject: "/application/config_definition",
    },
    component: () => import("../views/pages/application/config_definition"),
  },
  {
    path: "/application/params",
    name: "application_params",
    meta: {
      authRequired: true,
      access: "application",
      accessObject: "/application/params",
    },
    component: () => import("../views/pages/application/app_params_keys"),
  },
  {
    path: "/app/application_media",
    name: "application_media",
    meta: {
      authRequired: true, 
      access: "application_media",
      accessObject: "/app/application_media",
    },
    component: () => import("../views/pages/app/manage_application_media"),
  },
  {
    path: "/all_orders",
    name: "All Orders",
    meta: {
      authRequired: true,
      access: "all_orders",
      accessObject: "/all_orders",
    },
    component: () => import("../views/pages/orders/index"),
  },
  {
    path: "/service_tickets",
    name: "Service Tickets",
    meta: {
      authRequired: false,
      access: "service_tickets",
      accessObject: "/service_tickets",
    },
    component: () => import("../views/pages/ticketing/service_tickets"),
  },
  // {
  //   path: "/merchandising/products",
  //   name: "merchandising_products",
  //   meta: {
  //     authRequired: true,
  //     access: "merchandising",
  //   },
  //   component: () => import("../views/pages/merchandising/products"),
  //   props: true,
  // },
  // {
  //   path: "/merchandising/products/:id",
  //   name: "merchandising_product",
  //   meta: {
  //     authRequired: true,
  //     access: "merchandising",
  //   },
  //   component: () => import("../views/pages/merchandising/product_details"),
  //   props: true,
  // },
  {
    path: "/financials",
    name: "Transactions",
    meta: {
      authRequired: true,
      access: "financials",
      accessObject: "/financials",
    },
    component: () => import("../views/pages/financials/index"),
  },
  {
      path: "/financials/stripe_payouts",
      name: "Stripe Payouts",
      meta: {
         authRequired: true,
         access: "financials",
         accessObject: "/financials/stripe_payouts",
      },
     component: () => import("../views/pages/financials/stripe_payouts"),
  },
  {
    path: "/cashless",
    name: "Cards management",
    meta: {
      authRequired: true,
      access: "cashless",
      accessObject: "/cashless",
    },
    component: () => import("../views/pages/cashless/index"),
  },
  {
    path: "/topup",
    name: "Topup",
    meta: {
      authRequired: true,
      access: "cashless",
      accessObject: "/topup",
    },
    component: () => import("../views/pages/cashless/topup"),
  },
  {
    path: "/profile",
    name: "User Profile management",
    meta: {
      authRequired: true,
      access: "profile",
      accessObject: "/profile",
    },
    component: () => import("../views/pages/account/profile"),
  },
  {
    path: "/users",
    name: "Users management",
    meta: {
      authRequired: true,
      access: "users",
      accessObject: "/users",
    },
    component: () => import("../views/pages/account/users"),
  },
  {
    path: "/cashless/card-details/:id",
    name: "Card details",
    meta: {
      authRequired: true,
      access: "cashless",
      accessObject: "/cashless/card-details/:id",
    },
    component: () => import("../views/pages/cashless/card-details"),
  },
  {
    path: "/ticketing/season_tickets",
    name: "Ticketing",
    meta: {
      authRequired: true,
      access: "ticketing",
      accessObject: "/ticketing/season_tickets",
    },
    component: () => import("../views/pages/ticketing/season_tickets"),
  },
  {
      path: "/ticketing/match_tickets",
      name: "Match Tickets",
      meta: {
          authRequired: true,
          access: "ticketing",
          accessObject: "/ticketing/match_tickets",
      },
      component: () => import("../views/pages/ticketing/match_tickets"),
  },
  {
    path: "/ticketing/tickets_matches",
    name: "Ticketing Matches",
    meta: {
      authRequired: true,
      access: "ticketing",
      accessObject: "/ticketing/tickets_matches",
    },
    component: () => import("../views/pages/ticketing/tickets_matches.vue"),
    },
  {
      path: "/ticketing/axess_setup",
      name: "Axess Setup",
      meta: {
          authRequired: true,
          access: "ticketing",
          accessObject: "/ticketing/axess_setup",
      },
      component: () => import("../views/pages/ticketing/axess_setup.vue"),
  },
  {
    path: "/ticketing/tickets_matches/tickets_match_details",
    name: "Ticketing Match Details ",
    meta: {
      authRequired: true,
      access: "ticketing",
      accessObject: "/ticketing/tickets_matches/tickets_match_details",
    },
    component: () => import("../views/pages/ticketing/tickets_match_details.vue"),
    props: true,
  },
  {
      path: "/ticketing/season_products",
      name: "Season Setup",
      meta: {
       authRequired: false,
       access: "ticketing",
       accessObject: "/ticketing/season_products",
      },
      component: () => import("../views/pages/ticketing/season_products"),
      props: true,
  },
  {
    path: "/ticketing/siip_setup",
    name: "SIIP Setup",
    meta: {
        authRequired: true,
        access: "ticketing",
        accessObject: "/ticketing/siip_setup",
    },
    component: () => import("../views/pages/ticketing/siip_setup.vue"),
  },
  {
    path: "/ticketing/section_setup",
    name: "Section setup",
    meta: {
      authRequired: true,
      access: "ticketing",
      accessObject: "/ticketing/section_setup",
    },
    component: () => import("../views/pages/ticketing/section_setup.vue"),
  },
    {
      path: "/ticketing/ticketing_data",
      name: "Ticketing Data",
      meta: {
          authRequired: true,
          access: "ticketing_data",
          accessObject: "/ticketing/ticketing_data",
      },
      component: () => import("../views/pages/ticketing/ticketing_data.vue"),
},
  // {
  //   path: "/fixtures/matches",
  //   name: "matches",
  //   meta: {
  //     authRequired: true,
  //     access: "fixtures",
  //     accessObject: "/fixtures/matches",
  //   },
  //   component: () => import("../views/pages/fixtures/matches.vue"),
  // },
  {
    path: "/fixtures/matches_new",
    name: "matches_new",
    meta: {
      authRequired: true,
      access: "fixtures",
      accessObject: "/fixtures/matches_new",
    },
    component: () => import("../views/pages/fixtures/matches_new.vue"),
  },
  {
    path: "/fixtures/matches_new/:id",
    name: "match_new",
    meta: {
      authRequired: true,
      access: "fixtures",
      accessObject: "/fixtures/matches_new/:id",
    },
    component: () => import("../views/pages/fixtures/match_simulator_new.vue"),
  },
  // {
  //   path: "/fixtures/matches/:id",
  //   name: "match",
  //   meta: {
  //     authRequired: true,
  //     access: "fixtures",
  //     accessObject: "/fixtures/matches/:id",
  //   },
  //   component: () => import("../views/pages/fixtures/match_simulator.vue"),
  // },
  {
      path: "/fixtures/competition",
      name:"Competition Fixtures",
      meta: {
          authRequired:true,
          access: "fixtures",
          accessObject:"/fixtures/competition"
      },
      component: () => import("../views/pages/fixtures/competition_fixtures.vue")
  },
  {
      path: "/fixtures/current",
      name: "Fixture",
      meta: {
          authRequired:true,
          access: "fixtures",
          accessObject:"/fixtures/current"
      },
      component: () => import("../views/pages/fixtures/fixturesList.vue")
  },
  {
      path: "/fixtures/current/:id",
      name: "Fixtures Details",
      meta: {
          authRequired:false,
          access: "fixtures",
          accessObject:"/fixtures/current/:id"
      },
      component: () => import("../views/pages/fixtures/fixture.vue")
  },
  {
    path: "/fixtures/friendly_matches",
    name: "friendly_matches",
    meta: {
      authRequired: true,
      access: "fixtures",
      accessObject: "/fixtures/friendly_matches",
    },
    component: () => import("../views/pages/fixtures/friendly_matches.vue"),
  },
  {
    path: "/app/popup",
    name: "Marketing Popup",
    meta: {
      authRequired: true,
      access: "app",
      accessObject: "/app/popup",
    },
    component: () => import("../views/pages/app/popup.vue"),
  },
  {
    path: "/app/giveaway_popup",
    name: "Giveaway Popup",
    meta: {
      authRequired: true,
      access: "app",
      accessObject: "/app/giveaway_popup",
    },
    component: () => import("../views/pages/app/giveawayPopup.vue"),
  },
  {
    path: "/app/popup/:id",
    name: "Marketing Popup Details",
    meta: {
      authRequired: true,
      access: "app",
      accessObject: "/app/popup/:id",
    },
    component: () => import("../views/pages/app/popup_participation_details.vue"),
  },
    {
        path: "/app/app_params",
        name: "Application Params",
        meta: {
            authRequired: true,
            access: "app",
            accessObject: "/app/app_params",
        },
        component: () => import("../views/pages/app/app_params.vue"),
    },
    {
        path: "/app/app_crm_mimic",
        name: "Application Crm Mimic",
        meta: {
            authRequired: true,
            access: "app",
            accessObject: "/app/app_crm_mimic",
        },
        component: () => import("../views/pages/app/app_crm_mimic.vue"),
    },
    {
        path: "/app/profile_fields",
        name: "Profile Fields",
        meta: {
            authRequired: true,
            access: "app",
            accessObject: "/app/profile_fields",
        },
        component: () => import("../views/pages/app/profile_fields.vue"),
    },
    {
      path: "/app/settings",
      name: "Settings",
      meta: {
        authRequired: true,
        access: "app",
        accessObject: "/app/settings",
      },
      component: () => import("../views/pages/app/settings.vue"),
    },
  {
    path: "/app/app_deeplink_campaign",
    name: "Application Deeplink Campaign",
    meta: {
      authRequired: true,
      access: "app",
      accessObject: "/app/app_deeplink_campaign",
    },
    component: () => import("../views/pages/app/app_deeplink_campaign.vue"),
  },
  {
    path: "/app/links",
    name: "application_links",
    meta: {
      authRequired: true,
      access: "application_links",
      accessObject: "/app/links",
    },
    component: () => import("../views/pages/app/application_links"),
    props: true,
  },
  
    {
        path: "/media/media_management",
        name: "Media Management",
        meta: {
            authRequired: true,
            access: "media",
            accessObject: "/media/media_management",
        },
        component: () => import("../views/pages/media/media_management.vue"),
    },
  {
    path: "/social/social_levels",
    name: "Social Levels",
    meta: {
      authRequired: true,
      access: "social",
      accessObject: "/social/social_levels",
    },
    component: () => import("../views/pages/social/social_levels.vue"),
  },
  {
    path: "/social/social_milestone",
    name: "Social Milestone",
    meta: {
      authRequired: true,
      access: "social",
      accessObject: "/social/social_milestone",
    },
    component: () => import("../views/pages/social/social_milestone.vue"),
  },
  {
    path: "/social/social_xp",
    name: "Social xp",
    meta: {
      authRequired: true,
      access: "social",
      accessObject: "/social/social_xp",
    },
    component: () => import("../views/pages/social/social_xp.vue"),
  },
  {
    path: "/sport_data/tenant_setup",
    name: "Tenant Setup",
    meta: {
      authRequired: true,
      access: "sport_data",
      accessObject: "/sport_data/tenant_setup",
    },
    component: () => import("../views/pages/monitor/tenant_setup.vue"),
  },
  {
    path: "/sport_data/tenant_tournament",
    name: "Tenant Tournament",
    meta: {
      authRequired: true,
      access: "sport_data",
      accessObject: "/sport_data/tenant_tournament",
    },
    component: () => import("../views/pages/monitor/tenant_tournament.vue"),
  },
  {
     path: "/sport_data/sport_team",
     name: "Sport Team",
     meta: {
       authRequired: true,
       access: "sport_data",
       accessObject: "/sport_data/sport_team",
     },
     component: () => import("../views/pages/monitor/sport_team.vue"),
    },
    {
      path: "/sport_data/competitions",
      name: "Competitions",
      meta: {
         authRequired: true,
         access: "sport_data",
         accessObject: "/sport_data/competitions",
     },
       component: () => import("../views/pages/monitor/competitions.vue"),
    },
  {
    path: "/ssl/ssl_links",
    name: "SSL Links",
    meta: {
      authRequired: true,
      access: "ssl",
      accessObject: "/ssl/ssl_links",
    },
    component: () => import("../views/pages/ssl/ssl_links.vue"),
  },
  {
    path: "/monitor/url_monitor",
    name: "URL",
    meta: {
      authRequired: true,
      access: "url_monitor",
      accessObject: "/monitor/url_monitor",
    },
    component: () => import("../views/pages/monitor/url_monitor.vue"),
  },
  {
    path: "/monitor/vpn_users",
    name: "VPN Users",
    meta: {
      authRequired: true,
      access: "vpn_users",
      accessObject: "/monitor/vpn_users",
    },
    component: () => import("../views/pages/monitor/vpn_users.vue"),
  },
  {
    path: "/tenant_vpnusers",
    name: "VPN Users Management",
    meta: {
      authRequired: true,
      access: "tenant_vpn_users",
      accessObject: "/monitor/tenant_vpn_users",
    },
    component: () => import("../views/pages/monitor/tenant_vpn_users.vue"),
  },

  {
    path: "/version",
    name: "version",
    component: () => import("../views/pages/account/version"),
  },
  {
    path: "/forgot_password",
    name: "forgot_password",
    component: () => import("../views/pages/auth/forgot_password.vue"),
  },
  {
    path: "/monitor/dashboard_announcements",
    name: "Dashboard Announcements",
    meta: {
      authRequired: true,
      access: "dashboard_announcements",
      accessObject: "/monitor/dashboard_announcements",
    },
    component: () => import("../views/pages/monitor/dashboard_announcements.vue"),
  },
  {
    path: "/aws/instances",
    name: "AWS Instances",
    meta: {
      authRequired: true,
      access: "aws_instances",
      accessObject: "/aws/instances",
    },
    component: () => import("../views/pages/monitor/aws/instances"),
  },
  {
    path: "/aws/instances/:id",
    name: "Instance Details",
    meta: {
      authRequired:true,
      access: "aws_instances",
      accessObject:"/aws/instances/:id"
    },
    component: () => import("../views/pages/monitor/aws/instance_details.vue")
  },
  {
    path: "/aws/loadbalancers",
    name: "AWS Load Balancers",
    meta: {
      authRequired: true,
      access: "aws_loadbalancers",
      accessObject: "/aws/loadbalancers",
    },
    component: () => import("../views/pages/monitor/aws/loadbalancers"),
  },
  {
    path: "/aws/targetgroups",
    name: "AWS Target Groups",
    meta: {
      authRequired: true,
      access: "aws_targetgroups",
      accessObject: "/aws/targetgroups",
    },
    component: () => import("../views/pages/monitor/aws/targetgroups"),
  },
  {
    path: "/aws/targetgroups/:id",
    name: "Target Group Details",
    meta: {
      authRequired:true,
      access: "aws_targetgroups",
      accessObject:"/aws/targetgroups"
    },
    component: () => import("../views/pages/monitor/aws/targetgroup_details.vue")
  },
  {
    path: "/aws/rdsinstances",
    name: "AWS DB Instances",
    meta: {
      authRequired:true,
      access: "aws_rdsinstances",
      accessObject:"/aws/rdsinstances"
    },
    component: () => import("../views/pages/monitor/aws/rdsinstances.vue")
  },
  {
    path: "/aws/applications",
    name: "AWS Applications",
    meta: {
      authRequired:true,
      access: "aws_applications",
      accessObject:"/aws/applications"
    },
    component: () => import("../views/pages/monitor/aws/applications.vue")
  },
  {
    path: "/aws/applications/:id",
    name: "Application Details",
    meta: {
      authRequired:true,
      access: "aws_applications",
      accessObject:"/aws/applications"
    },
    component: () => import("../views/pages/monitor/aws/application_details.vue")
  },
  {
    path: "/aws/securitygroups",
    name: "AWS Security Groups",
    meta: {
      authRequired: true,
      access: "aws_securitygroups",
      accessObject: "/aws/securitygroups",
    },
    component: () => import("../views/pages/monitor/aws/securitygroups"),
  },
  {
    path: "/aws/autoscalinggroups",
    name: "AWS Auto Scaling Groups",
    meta: {
      authRequired: true,
      access: "aws_autoscalinggroups",
      accessObject: "/aws/autoscalinggroups",
    },
    component: () => import("../views/pages/monitor/aws/autoscaling_groups"),
  },
  {
    path: "/aws/scheduler",
    name: "AWS Auto Scheduler",
    meta: {
      authRequired: true,
      access: "aws_scheduler",
      accessObject: "/aws/scheduler",
    },
    component: () => import("../views/pages/monitor/aws/scheduler"),
  },
  {
    path: "/ip/management",
    name: "Security Group IP Rules",
    meta: {
      authRequired: true,
      access: "aws_securitygroup_tenantrules",
      accessObject: "/aws/securitygroup/tenantrules",
    },
    component: () => import("../views/pages/monitor/aws/securitygroup_tenantrules"),
  },
  {
    path: "/aws/parameter_store",
    name: "AWS Parameter Store",
    meta: {
      authRequired: true,
      access: "aws_parameter_store",
      accessObject: "/aws/parameter_store",
    },
    component: () => import("../views/pages/monitor/aws/parameter_store"),
  },
  {
    path: "/cron_setup/list_cron_scheduled_tasks",
    name: "Cron Scheduled Tasks",
    meta: {
      authRequired: true,
      access: "list_cron_scheduled_tasks",
      accessObject: "/cron_setup/list_cron_scheduled_tasks",
    },
    component: () => import("../views/pages/monitor/cron/cron_scheduled_tasks_list"),
  },
  {
    path: "/caching",
    name: "Caching",
    meta: {
      authRequired: true,
      access: "caching",
      accessObject: "/caching",
    },
    component: () => import("../views/pages/monitor/caching"),
  },
  {
    path: "/cron_setup/list_cron_execution",
    name: "Cron Execution",
    meta: {
      authRequired: true,
      access: "list_cron_execution",
      accessObject: "/cron_setup/list_cron_execution",
    },
    component: () => import("../views/pages/monitor/cron/cron_execution"),
  },
  {
    path: "/monitor/collectibles",
    name: "Monitor Collectibles",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/monitor/collectibles",
    },
    component: () => import("../views/pages/monitor/collectibles"),
    props: true,
  },
  {
    path: "/dashboard/changelog",
    name: "dashboard_version",
    meta: {
      authRequired: true,
      access: "dashboard_version",
      accessObject: "/dashboard/changelog",
    },
    component: () => import("../views/pages/dashboard/dashboard_version"),
  },
  {
    path: "/dashboard/changelog/manage",
    name: "dashboard_changelog_manage",
    meta: {
      authRequired: true,
      access: "dashboard_manage_changelog",
      accessObject: "/dashboard/changelog/manage",
    },
    component: () => import("../views/pages/dashboard/changelog_manage"),
  },
  {
    path: "/api/changelog",
    name: "api_changelog",
    meta: {
      authRequired: true,
      access: "api_changelog",
      accessObject: "/api/changelog",
    },
    component: () => import("../views/pages/dashboard/api_changelog"),
  },
  {
    path: "/statistics/login",
    name: "statistics_login",
    meta: {
      authRequired: true,
      access: "statistics_login",
      accessObject: "/statistics/login",
    },
    component: () => import("../views/pages/monitor/statistics/login_statistics"),
  },
  /*
  {
    path: "/games/matches",
    name: "matches",
    meta: {
      authRequired: true,
      access: "games",
      accessObject: "/games/matches",
    },
    component: () => import("../views/pages/games/matches.vue"),
  },
  {
    path: "/games/matches/:id",
    name: "match",
    meta: {
      authRequired: true,
      access: "games",
      accessObject:"/games/matches/:id",
    },
    component: () => import("../views/pages/games/match_simulator.vue"),
  },
  */




/*
  template routes
  {
    path: "/calendar",
    name: "calendar",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/calendar/index"),
  },
  {
    path: "/chat",
    name: "chat",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/chat/index"),
  },
  {
    path: "/ecommerce/products",
    name: "Products",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-detail/:id",
    name: "Product Detail",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/product-detail"),
  },
  {
    path: "/ecommerce/orders",
    name: "Ecomerce Orders",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/orders"),
  },
  {
    path: "/ecommerce/customers",
    name: "Customers",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/customers"),
  },
  {
    path: "/ecommerce/cart",
    name: "Cart",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/cart"),
  },
  {
    path: "/ecommerce/checkout",
    name: "Checkout",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/shops",
    name: "Shops",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/shops"),
  },
  {
    path: "/ecommerce/add-product",
    name: "Add Product",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ecommerce/add-product"),
  },
  {
    path: "/email/inbox",
    name: "Inbox",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/email/inbox"),
  },
  {
    path: "/email/reademail/:id",
    name: "Read Email",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/email/reademail"),
  },
  {
    path: "/invoices/detail",
    name: "Invoice Detail",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/invoices/detail"),
  },
  {
    path: "/invoices/list",
    name: "Invoice List",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/invoices/list"),
  },
  {
    path: "/contacts/grid",
    name: "User Grid",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/contacts/grid"),
  },
  {
    path: "/contacts/profile",
    name: "Profile",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/contacts/profile"),
  },
  {
    path: "/utility/starter",
    name: "Starter-page",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/starter"),
  },
  {
    path: "/utility/maintenance",
    name: "maintenance",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/maintenance"),
  },
  {
    path: "/utility/comingsoon",
    name: "comingsoon",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/comingsoon"),
  },
  {
    path: "/utility/timeline",
    name: "timeline",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/timeline"),
  },
  {
    path: "/utility/faqs",
    name: "faqs",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/faqs"),
  },
  {
    path: "/utility/pricing",
    name: "pricing",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/pricing"),
  },
  {
    path: "/utility/404",
    name: "error-404",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/404"),
  },
  {
    path: "/utility/500",
    name: "error-500",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/utility/500"),
  },
  {
    path: "/form/elements",
    name: "elements",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/elements"),
  },
  {
    path: "/form/validation",
    name: "validation",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/validation"),
  },
  {
    path: "/form/advanced",
    name: "form-advanced",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/advanced"),
  },
  {
    path: "/form/editor",
    name: "editor",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/editor"),
  },
  {
    path: "/form/upload",
    name: "upload",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/upload"),
  },
  {
    path: "/form/repeater",
    name: "repeater",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/repeater"),
  },
  {
    path: "/form/wizard",
    name: "wizard",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/wizard"),
  },
  {
    path: "/form/mask",
    name: "mask",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/form/mask"),
  },
  {
    path: "/tables/basic",
    name: "basic-table",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/tables/basic"),
  },
  {
    path: "/tables/advanced",
    name: "advanced",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/tables/advanced"),
  },
  {
    path: "/charts/apex",
    name: "apex",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/charts/apex/index"),
  },
  {
    path: "/charts/chartist",
    name: "chartist",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/charts/chartist/index"),
  },
  {
    path: "/charts/chartjs",
    name: "chartjs",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/charts/chartjs/index"),
  },
  {
    path: "/charts/echart",
    name: "echart",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/charts/echart/index"),
  },
  {
    path: "/icons/unicons",
    name: "unicons",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/icons/unicons"),
  },
  {
    path: "/icons/boxicons",
    name: "boxicons",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/icons/boxicons"),
  },
  {
    path: "/icons/materialdesign",
    name: "materialdesign",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/icons/materialdesign"),
  },
  {
    path: "/icons/dripicons",
    name: "dripicons",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/icons/dripicons"),
  },
  {
    path: "/icons/fontawesome",
    name: "fontawesome",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/icons/fontawesome"),
  },
  {
    path: "/maps/google",
    name: "google",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/maps/google"),
  },
  {
    path: "/maps/leaflet",
    name: "leaflet",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/maps/leaflet"),
  },
  {
    path: "/ui/alerts",
    name: "alerts",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/alerts"),
  },
  {
    path: "/ui/buttons",
    name: "buttons",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/buttons"),
  },
  {
    path: "/ui/cards",
    name: "cards",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/cards"),
  },
  {
    path: "/ui/carousel",
    name: "carousel",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/carousel"),
  },
  {
    path: "/ui/dropdown",
    name: "dropdown",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/dropdown"),
  },
  {
    path: "/ui/grid",
    name: "grid",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/grid"),
  },
  {
    path: "/ui/images",
    name: "images",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/images"),
  },
  {
    path: "/ui/lightbox",
    name: "lightbox",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/lightbox"),
  },
  {
    path: "/ui/modals",
    name: "modals",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/modals"),
  },
  {
    path: "/ui/rangeslider",
    name: "rangeslider",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/rangeslider"),
  },
  {
    path: "/ui/progressbar",
    name: "progressbar",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/progressbar"),
  },
  {
    path: "/ui/placeholder",
    name: "placeholder",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/placeholder"),
  },
  {
    path: "/ui/sweet-alert",
    name: "sweet-alert",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/sweet-alert"),
  },

  {
    path: "/ui/tabs-accordions",
    name: "tabs-accordions",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/tabs-accordions"),
  },
  {
    path: "/ui/typography",
    name: "typography",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/typography"),
  },

  {
    path: "/ui/video",
    name: "video",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/video"),
  },
  {
    path: "/ui/general",
    name: "general",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/general"),
  },
  {
    path: "/ui/colors",
    name: "colors",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/colors"),
  },
  {
    path: "/ui/rating",
    name: "rating",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/ui/rating"),
  },
  {
    path: "/auth/login-1",
    name: "login-1",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/auth/login-1"),
  },
  {
    path: "/auth/register-1",
    name: "register-1",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/auth/register-1"),
  },
  {
    path: "/auth/lock-screen",
    name: "lock-screen",
    meta: {
      authRequired: true,
      access: "template",
    },
    component: () => import("../views/pages/auth/lock-screen"),
  },

 */



];
